import React from "react";
import Link, { type LinkProps } from "../component";

export type MapProps = Omit<LinkProps, "href"> & {};

export type ActionProps = {
  onClick: (e: React.MouseEvent) => void;
};

export default React.forwardRef(
  ({ id, htmlId, preventRedirect, ...props }: ActionProps & MapProps, ref: React.RefObject<any>) => {
    const style = React.useMemo(
      () => ({ ...props.style, cursor: props.isNoRedirect ? "default" : "pointer" }),
      [props.isNoRedirect, props.style]
    );

    return <Link ref={ref} {...props} htmlId={htmlId} preventRedirect={preventRedirect} style={style} />;
  }
);
